<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="!$v.detail.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-typeahead(url="suppliers" :label='$t("quotations_detail.supplier_id")' required :data="quotationsCatalog.suppliers" :placeholder='$t("quotations_detail.supplier_id")' :danger="!$v.detail.supplier.required" danger-text="Supplier is required" v-model="detail.supplier" :filter="query => `?param=${query},name`" :serializer="item => item.name" @input-change="autoCompleteFunc" :defaultValue="detail.supplier && detail.supplier.name ? detail.supplier.name : ''")
            template(slot-scope="{data}")
              vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data" v-bind:text="item.text" v-for="item,index in data")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("quotations_detail.quantity_placeholder")' :danger="!$v.detail.quantity" :danger-text="'Quantity is required'" v-model="detail.quantity" :label='$t("quotations_detail.quantity")' type="number")
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-typeahead(url="products" :label='$t("quotations_detail.product_id")' :serializer="item => item.sku + ' - ' + item.name + ' - ' + item.number_part" required :data="quotationsCatalog.products" :placeholder='$t("quotations_detail.product_id")' :danger="!$v.detail.product.required" danger-text="Product is required" v-model="detail.product" :filter="query => `?param=${query},name,sku,number_part`" @input-change="autoCompleteFunc" :defaultValue="detail.product && detail.product.name ? detail.product.name : ''")
            template(slot-scope="{data}")
              vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data" v-bind:text="item.text" v-for="item,index in data")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:description-text="detail.product?'Costo del produco en: '+detail.product.currency.code:''" :danger="!$v.detail.unit_price.required" :danger-text="'Unit Price is required'" v-model="unit_price" :label='$t("quotations_detail.unit_price")' type="number")
</template>

<script>
import { required, decimal } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Quotations')

export default {
  name: 'ModalQuotationsDetail',
  props: {
    detail: {
      type: Object,
      default: () => 0
    },
    index: {
      type: Number,
      default: () => 0
    },
    currency: {
      type: Number,
      default: () => 0
    },
    exchange_rate: {
      type: Number,
      default: () => 0
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  data: () => ({
    unit_price: 0
  }),
  validations: {
    detail: {
      quantity: {
        required,
        decimal
      },
      unit_price: {
        required
      },
      product: {
        required
      },
      supplier: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalVisible',
      'quotationsCatalog'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('quotations_detail.add') : this.$t('quotations_detail.edit')
    }
  },
  watch: {
    'detail.product' (product) {
      if (!product) return
      this.setInput(product.price)
    }
  },
  methods: {
    ...mapActions([
      'addQuotationDetail',
      'editQuotationDetail',
      'setModalVisible',
      'loadCatalog'
    ]),
    setInput (value) {
      this.unit_price = value
      this.detail.unit_price = value
      this.detail.unit_price_raw = value
    },
    async saveRecord () {
      this.detail.edit = true
      this.detail.unit_price = this.unit_price
      this.detail.unit_price_raw = this.unit_price
      await this.isAdd ? this.addQuotationDetail(this.detail) : this.editQuotationDetail({ detail: this.detail, index: this.index })
      this.detail.quantity = ''
      this.detail.product = ''
      this.unit_price = 0
    },
    async getCatalog () {
      Object.keys(this.quotationsCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
</style>
